import { styled } from "styled-components";

interface ButtonProps {
  backgroundColor: string;
  hoverBackgroundColor: string;
  color?: string;
}
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const WrapperButton = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
  padding-right: 10px;
`;
export const Button = styled.button<ButtonProps>`
  display: flex;
  align-items: center;
  gap: 5px;
  background-color: ${(props) => props.backgroundColor};
  border: none;
  border-radius: 99px;
  padding: 10px;
  color: ${(props) => props.color || "#fff"};
  font-family: "Archivo-Regular";
  cursor: pointer;
  &:hover {
    transition: all 0.2s;
    background-color: ${(props) => props.hoverBackgroundColor};
  }
`;

export const WrapperCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%;
  padding: 2rem 2rem;
  @media (max-width: 426px) {
    gap: 20px;
    padding: 0 0 10px 0;
  }
`;

export const TextModal = styled.h2`
  color: #2c2c2c;
  text-align: center;
  padding: 12px;
  margin-bottom: 15px;
  @media (max-width: 426px) {
    font-size: 22px;
    margin-bottom: 15px;
  }
`;
export const RequiredMessage = styled.span`
  padding: 0;
  color: red;
  font-size: 12px;
`;
